import { PriceType } from '@wix/ambassador-forms-v4-form/types';
import { EMPTY_VALUE } from '../../constants';
export function acceptOnlyValidPayments({ field, fieldValue }) {
    const isEmptyValue = fieldValue === EMPTY_VALUE;
    const { validation } = field;
    const payment = validation?.predefined?.paymentOptions?.products?.[0];
    if (isEmptyValue && payment?.priceType === PriceType.FIXED_PRICE) {
        return [
            {
                productId: payment.id,
                price: payment.fixedPriceOptions?.price,
                quantity: 1
            }
        ];
    }
    if (isEmptyValue) {
        return fieldValue;
    }
    if (!Array.isArray(fieldValue)) {
        return EMPTY_VALUE;
    }
    return fieldValue;
}

//# sourceMappingURL=payment-input-normalize-value.js.map